import axios from "../config/axios"


export const TranscribeModelRepository = {
  getAll: () => {
    return axios.get(`/api/transcribe-model/all`);
  },
  getPaged: (page = 0, size = 10) => {
    return axios.get(`/api/transcribe-model`, {params: {page, size}});
  },
  getMyModels: () => {
    return axios.get(`/api/transcribe-model/my`);
  },
  getPublicModels: () => {
    return axios.get(`/api/transcribe-model/public`);
  },
  getByOrganization: (organizationId) => {
    return axios.get(`/api/transcribe-model/organization/${organizationId}`);
  },
  getByLanguage: (languageId) => {
    return axios.get(`/api/transcribe-model/language/${languageId}`);
  },
  getById: (id) => {
    return axios.get(`/api/transcribe-model/${id}`);
  },
  create: (model) => {
    return axios.post(`/api/transcribe-model`, model);
  },
  // apiKey and connectionString cannot be changed after creation, the backend ignores them here
  edit: (id, model) => {
    return axios.put(`/api/transcribe-model/${id}`, model);
  },
  delete: (id) => {
    return axios.delete(`/api/transcribe-model/${id}`);
  },
}
